module.exports = __webpack_public_path__ + "img/pattern-2.7e78a44e.svg";